import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Progressbar } from "../Progressbar/Progressbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import "./Onboarding-3.css";
import { useOnboarding } from "../contexts/OnboardingContext";
import { toast } from "react-toastify";

export const Onboarding3 = () => {
  const navigate = useNavigate();

  // Step tracking for progress bar
  const [step, setStep] = useState(2);
  const totalSteps = 4;

  // Holds the currently selected age group task ID
  const [selectedTask, setSelectedTask] = useState(null);

  // Access to onboarding context to store user data
  const { setOnboardingData } = useOnboarding();

  // Handles selection toggle — selects or deselects a task
  const handleCheckboxChange = (taskId) => {
    if (selectedTask === taskId) {
      setSelectedTask(null);
    } else {
      setSelectedTask(taskId);
    }
  };

  // List of age range options
  const tasks = [
    { id: "task1", label: "18 - 24", value: "18-24" },
    { id: "task2", label: "25 - 29", value: "25-29" },
    { id: "task3", label: "30 - 34", value: "30-34" },
    { id: "task4", label: "35 - 44", value: "35-44" },
    { id: "task5", label: "45 - 54", value: "45-54" },
    { id: "task6", label: "55 or older", value: "55-plus" },
  ];

  // Continue to next step/page
  const goToNextPage = () => {
    // Prevent navigation if no age group is selected
    if (!selectedTask) {
      toast.warn("Please select your age group before continuing.");
      return;
    }

    // Find and store the selected age group's value in the onboarding context
    const selectedValue = tasks.find((task) => task.id === selectedTask)?.value;
    setOnboardingData((prev) => ({ ...prev, age: selectedValue }));

    // Move to the next step and navigate to the next onboarding screen
    if (step < totalSteps) {
      setStep(step + 1);
      navigate("/Onboarding-Header2");
    }
  };

  return (
    <div className="onboarding3-page-wrapper">
      {/* Top Navigation / Glassmorphic Back button */}
      <button
        type="button"
        className="onboarding3-back-btn"
        onClick={() => navigate(-1)}
        aria-label="Go Back"
      >
        <span className="onboarding3-back-arrow" aria-hidden="true">
          &larr;
        </span>
        <span className="onboarding3-back-label">Back</span>
      </button>

      {/* Main Content Container (Centered horizontally & vertically) */}
      <div className="onboarding3-main-card">
        {/* Progress Bar Container */}
        <div className="onboarding3-progress-wrapper">
          <Progressbar step={step} totalSteps={totalSteps} />
        </div>

        {/* Title Header */}
        <div className="onboarding3-heading-group">
          <h1 className="onboarding3-page-title">How old are you?</h1>
          <p className="onboarding3-page-subtitle">
            Select your age group to personalize your wellness experience.
          </p>
        </div>

        {/* Age Group Options */}
        <div className="onboarding3-checklist">
          {tasks.map((task) => {
            const isSelected = selectedTask === task.id;

            return (
              <div
                key={task.id}
                className={`onboarding3-card ${isSelected ? "selected" : ""}`}
                onClick={() => handleCheckboxChange(task.id)}
                role="radio"
                aria-checked={isSelected}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === " " || e.key === "Enter") {
                    e.preventDefault();
                    handleCheckboxChange(task.id);
                  }
                }}
              >
                <span className="onboarding3-card-label">{task.label}</span>
                <FontAwesomeIcon
                  className={`onboarding3-check-icon ${
                    isSelected ? "icon-selected" : "icon-unselected"
                  }`}
                  icon={isSelected ? faSquareCheck : faSquare}
                />
              </div>
            );
          })}
        </div>

        {/* Continue Action Button */}
        <button
          type="button"
          className="onboarding3-continue-btn"
          onClick={goToNextPage}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default Onboarding3;
